import * as React from "react";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { defaultToastOptions, groupContext, openLoginMenu, setDTConfig, } from "../index.js";
import PlainEditor from "../../../../../../../merchant/panel/scripts/shared/editor/plainEditor.js";
import WindowComponent from "../../../../../../../merchant/panel/scripts/shared/window/window.js";
import executeRequest from "../../../../../modules/request.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import { useGlobalUpdate } from "../../scripts/useGlobalUpdate.js";
import { updateOneTimeOfferEmitter } from "../disposableOfferOrder/disposableOfferOrder.js";
import { UpdateBasketItemsCount } from "../navbar/navBar.js";
import { OneTimeOfferOrderingContainer } from "../oneTimeOfferOrderingContainer/oneTimeOfferOrderingContainer.js";
import "./oneTimeOffer.css";
export function CategoryOneTimeOffer(props) {
    var _a, _b;
    const group = React.useContext(groupContext);
    const { offer, categoryIndex } = props;
    const [ordered, setOrdered] = React.useState(false);
    const [windowOpen, setWindowOpen] = React.useState(false);
    const [logged, setLogged] = React.useState(false);
    const { useListener } = useGlobalUpdate(updateOneTimeOfferEmitter);
    const { emit, state } = useGlobalUpdate(UpdateBasketItemsCount);
    function login() {
        return new Promise((resolve, reject) => {
            var _a, _b;
            openLoginMenu({
                needsEmail: group.clientData.email,
                needsName: group.clientData.name,
                needsPhone: group.clientData.phone,
                flow: (_a = group.flow) === null || _a === void 0 ? void 0 : _a.onFirstOrderIntent,
                componentList: (_b = group === null || group === void 0 ? void 0 : group.flow) === null || _b === void 0 ? void 0 : _b.componentsList,
                onLogin() {
                    resolve();
                    setDTConfig((c) => ({ ...c, isLoggedIn: "true" }));
                    checkLogin();
                    emit(state + 1);
                },
                onExit() {
                    reject();
                    emit(state + 1);
                },
                allowLoginToOrder: group.allowLoginToOrder,
            });
        });
    }
    async function checkLogin() {
        const response = await executeRequest(`/api/public/users/gallery/oneTimeOffer/${group.categories[categoryIndex].name}/${offer.name}`, "GET", {});
        if (response.status === 401) {
            setLogged(false);
            return setOrdered(false);
        }
        setLogged(true);
        setOrdered(response.ordered);
    }
    React.useEffect(() => {
        checkLogin();
    }, []);
    useListener(() => {
        checkLogin();
    }, `one-time-offer-in-category-${props.offer.name}`);
    if (!windowOpen)
        document.querySelector("#offer-with-input-container").style.display = "none";
    if (windowOpen && ((_a = offer.textInput) === null || _a === void 0 ? void 0 : _a.enabled))
        document.querySelector("#offer-with-input-container").style.display = "block";
    return (React.createElement("div", { className: "one-time-offer-container" },
        React.createElement(PlainEditor, { editable: false, example: offer.descriptiveTitle, label: "", onChange: () => { } }),
        ordered ?
            React.createElement("span", { style: { color: "green" } }, "W koszyku \u2714")
            : React.createElement(Button, { text: offer.acceptButtonContent, value: "add_one_time_offer", onClick: async () => {
                    const { status, ordered } = await executeRequest(`/api/public/users/gallery/oneTimeOffer/${group.categories[categoryIndex].name}/${offer.name}`, "GET", {});
                    if (status === 401) {
                        await login();
                    }
                    if (status != 200)
                        return;
                    if (ordered === true) {
                        toast.error("Ta oferta została już dodana do koszyka", defaultToastOptions);
                        return;
                    }
                    setWindowOpen(true);
                } }),
        windowOpen &&
            (((_b = offer.textInput) === null || _b === void 0 ? void 0 : _b.enabled) === true ?
                ReactDOM.createPortal(React.createElement(OneTimeOfferOrderingContainer, { ...props, onExit: () => {
                        checkLogin();
                        setWindowOpen(false);
                    } }), document.querySelector("#offer-with-input-container"))
                : React.createElement("div", { className: "ordering-container" },
                    React.createElement(WindowComponent, { title: offer.acceptButtonContent, onExit: function () { }, onExited: function () {
                            setWindowOpen(false);
                        }, exit: !windowOpen },
                        React.createElement(OneTimeOfferOrderingContainer, { offer: offer, categoryIndex: props.categoryIndex, onExit: () => {
                                checkLogin();
                                setWindowOpen(false);
                            } }))))));
}
